<app-modal [title]="saveLabel" (onCloseClick)="fechar()" [saveLabel]="'Salvar'" [hideFooter]="false" [hideCancel]="true"
    (onSaveClick)="salvar()">

    <p class="pre-visualizacao-texto">
        {{paragrafoInicial}}
    </p>

    <div class="preview-box">
        <form-avaliacao [perguntas]="perguntas" [respostasSelecionadas]="respostasSelecionadas"></form-avaliacao>
    </div>
</app-modal>